<script>
import { mapState } from "vuex";
import umatOpt from "@/data/umatOpt";
import umatData from "@/data/umat";

export default {
	name: "compKeluargaKatolik",
	props: ["triggerValidation"],
	data() {
		return {
			myOptions: {
				jenis: umatOpt.jenis,
				kriteria: umatOpt.kriteria,
				paroki: umatData.paroki,
				kabupaten: umatData.kabupaten,
				kecamatan: umatData.kecamatan,
				desa: umatData.desa,
			},
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			keluargaKatolikItem: (state) => state.keluargaKatolik.item,
			lingkunganStasi: (state) => state.service.lingkunganStasi,
		}),
	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		triggerValidation: function (_newVal, _oldVal) {
			this.trigger();
		},
	},
	methods: {
		validateState(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				return !this.veeErrors.has(ref);
			}
			return null;
		},
		validateStateCustom(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				if (this.veeErrors.has(ref)) {
					return { "is-invalid": true };
				} else {
					return { "is-valid": true };
				}
			}
			return null;
		},
		trigger() {
			this.$emit("validate", this.$validator.validateAll());
			this.$validator.validateAll();
		},
	},
};
</script>

<template>
	<div class="form theme-form">
		<div class="row">
			<div class="col-md-6">
				<div class="form-group">
					<label>Nomor<span class="text-danger">*</span></label>
					<b-form-input
						name="nomor"
						v-model="keluargaKatolikItem.nomor"
						v-validate="{ required: true }"
						:state="validateState('nomor')"
						data-vv-as="Nomor"
						size="sm"
						disabled
						description="Tidak bisa di ubah."
					></b-form-input>
					<small tabindex="-1" class="form-text text-muted"
						>Tidak bisa diubah.</small
					>
					<b-form-invalid-feedback>{{
						veeErrors.first("nomor")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Paroki <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="paroki"
						:class="validateStateCustom('paroki')"
						data-vv-as="Paroki"
						v-validate="{ required: true }"
						v-model="keluargaKatolikItem.paroki"
						:minMatchingChars="1"
						:data="myOptions.paroki"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("paroki")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label
						>Lingkungan/Stasi <span class="text-danger">*</span></label
					>
					<vue-typeahead-bootstrap
						name="lingkungan_stasi"
						:class="validateStateCustom('lingkungan_stasi')"
						data-vv-as="Lingkungan/Stasi"
						v-validate="{ required: true }"
						v-model="keluargaKatolikItem.lingkungan_stasi"
						:minMatchingChars="1"
						:data="lingkunganStasi"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("lingkungan_stasi")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Kota/Kabupaten <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="kabupaten"
						:class="validateStateCustom('kabupaten')"
						data-vv-as="Kota/Kabupaten"
						v-validate="{ required: true }"
						v-model="keluargaKatolikItem.kabupaten"
						:minMatchingChars="1"
						:data="myOptions.kabupaten"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("kabupaten")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Kecamatan <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="kecamatan"
						:class="validateStateCustom('kecamatan')"
						data-vv-as="Kecamatan"
						v-validate="{ required: true }"
						v-model="keluargaKatolikItem.kecamatan"
						:minMatchingChars="1"
						:data="myOptions.kecamatan"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("kecamatan")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Kelurahan/Desa <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="desa"
						:class="validateStateCustom('desa')"
						data-vv-as="Kelurahan/Desa"
						v-validate="{ required: true }"
						v-model="keluargaKatolikItem.desa"
						:minMatchingChars="1"
						:data="myOptions.desa"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("desa")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Alamat <span class="text-danger">*</span></label>
					<b-form-textarea
						name="alamat"
						:state="validateState('alamat')"
						data-vv-as="Alamat"
						v-validate="{ required: true }"
						v-model="keluargaKatolikItem.alamat"
						size="sm"
					></b-form-textarea>

					<b-form-invalid-feedback>{{
						veeErrors.first("alamat")
					}}</b-form-invalid-feedback>
				</div>
			</div>
         
         <div class="col-md-6">
				<div class="form-group">
					<label>No. LM</label>

					<b-form-input
						name="no_lm"
						v-model="keluargaKatolikItem.no_lm"
						v-validate="{ required: false }"
						:state="validateState('no_lm')"
						data-vv-as="No. LM"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("no_lm")
					}}</b-form-invalid-feedback>
				</div>
			</div>         
         
         <div class="col-md-6">
				<div class="form-group">
					<label>Gereja</label>

					<b-form-input
						name="wali2"
						v-model="keluargaKatolikItem.gereja"
						v-validate="{ required: false }"
						:state="validateState('gereja')"
						data-vv-as="Gereja"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("gereja")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Jenis Perkawinan</label>
					<b-form-select
						name="jenis"
						:state="validateState('jenis')"
						data-vv-as="Jenis"
						v-validate="{ required: false }"
						v-model="keluargaKatolikItem.jenis"
						:options="myOptions.jenis"
						size="sm"
					></b-form-select>

					<b-form-invalid-feedback>{{
						veeErrors.first("jenis")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Dispensasi atau Izin</label>

					<b-form-input
						name="izin"
						v-model="keluargaKatolikItem.izin"
						v-validate="{ required: false }"
						:state="validateState('izin')"
						data-vv-as="Dispensasi atau Izin"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("izin")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>No. Catatan Sipil</label>

					<b-form-input
						name="no_sipil"
						v-model="keluargaKatolikItem.no_sipil"
						v-validate="{ required: false }"
						:state="validateState('no_sipil')"
						data-vv-as="No. Catatan Sipil"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("no_sipil")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Tanggal Catatan Sipil</label>
					<b-form-input
						name="tgl_sipil"
						:state="validateState('tgl_sipil')"
						data-vv-as="Tanggal Catatan Sipil"
						v-validate="{ required: false }"
						v-model="keluargaKatolikItem.tgl_sipil"
						size="sm"
						type="date"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("tgl_sipil")
					}}</b-form-invalid-feedback>
				</div>
			</div>
		</div>
	</div>
</template>

